import { menuWidth, shrunkMenuWidth } from "@saleor/components/Siderbar";
import { makeStyles } from "@saleor/macaw-ui";
interface PropsType {
  expandMenu?: boolean;
  fullScreen?: boolean;
  bodyPaddingRight?: number;
}
const useStyles = makeStyles<PropsType>(
  theme => ({
    menu: {
      zIndex: 100,
      padding: 0,
      position: "fixed",
      bottom: 0,
      right: 0,
      transition: "width 0.4s ease",
      width: "100%",
      [theme.breakpoints.up("md")]: {
        padding: "0 2.4rem",
        paddingRight: props => `calc(2.4rem + ${props.bodyPaddingRight}px)`,
        width: props => {
          if (props.fullScreen) {
            return "100%";
          }
          return props.expandMenu
            ? `calc(100% - ${menuWidth}px)`
            : `calc(100% - ${shrunkMenuWidth}px)`;
        }
      }
    },
    wrapper: {
      display: "block",
      width: "100%",
      alignItems: "center",
      boxShadow: "0px -8px 24px rgb(0 0 0 / 8%)",
      borderRadius: "20px 20px 0px 0px"
    },
    section: {
      display: "flex",
      padding: "1.6rem 2.4rem",
      justifyContent: "space-between",
      gap: "0 2.4rem"
    },
    divider: {
      margin: 0,
      border: 0,
      borderTop: `1px dashed ${theme.palette.grey[500]}`
    },
    summaryCaption: {
      color: theme.palette.grey[900]
    },
    number: {
      fontSize: "1.8rem",
      lineHeight: "2.4rem"
    },
    sectionRight: {
      display: "flex"
    },
    price: {
      minWidth: 152,
      marginRight: "2.4rem",
      "&:last-child": {
        marginRight: 0,
        minWidth: "75px"
      }
    },
    priceCaption: {
      color: theme.palette.grey[600],
      marginBottom: "0.6rem"
    },
    netPriceNumber: {
      "& span": {
        color: theme.palette.info.dark
      }
    },
    btnSaveDraft: {
      alignItems: "center",
      height: 48,
      padding: "0 13px",
      "& .MuiButton-label": {
        fontWeight: 700,
        gap: "0px"
      },
      "&.Mui-disabled": {
        "& .MuiButton-startIcon": {
          opacity: 0.3
        }
      }
    },
    btnSaveDraftBg: {
      background:
        "linear-gradient(90deg, #601863 0%, #681661 12%, #81125C 32%, #A90C55 57%, #DF044A 86%, #FD0045 100%)",
      border: "none",
      color: "#ffffff",
      "& .MuiTypography-root": {
        color: "#FFFFFF"
      },
      "&:hover": {
        border: "none"
      }
    },
    btnConfirmOrder: {
      color: "#ffffff",
      alignItems: "center",
      fontSize: "1.8rem",
      lineHeight: "2.8rem",
      height: 48,
      padding: "0 73px 0 74px",
      "& .MuiButton-label": {
        fontWeight: 700
      }
    },
    leftContainer: {
      display: "flex",
      alignItems: "center",
      "& button": {
        padding: "12px 27px",
        marginRight: "1.6rem"
      }
    },
    reversedButtons: {
      flexDirection: "row-reverse"
    },
    deleteItem: { color: "inherit !important" },
    btnAddProduct: {
      "& .MuiButton-label": {
        fontWeight: 700,
        fontSize: "1.6rem"
      }
    },
    btnDelete: {
      height: 48,
      fontSize: "1.6rem",
      lineHeight: "24px",
      minWidth: 160
    }
  }),
  { name: "BottomBarCreateOrder" }
);

export default useStyles;
